import Vue from "vue"

export const subdivisionStore = {
  state: {
    subdivision: {},
    managementSubdivisions: [],
    structuralSubdivisions: [],
    subdivisions: [],
  },
  mutations: {
    SET_SUBDIVISION_PROPERTY(state, { key, value }) {
      Vue.set(state.subdivision, key, value)
    },
    SET_SUBDIVISION(state, subdivision) {
      Vue.set(state, 'subdivision', subdivision)
    },
    SET_MANAGEMENT_SUBDIVISION(state, managementSubdivisions) {
      Vue.set(state, 'managementSubdivisions', managementSubdivisions)
    },
    SET_STRUCTURAL_SUBDIVISION(state, structuralSubdivisions) {
      Vue.set(state, 'structuralSubdivisions', structuralSubdivisions)
    },
    SET_SUBDIVISIONS(state, subdivisions) {
      Vue.set(state, 'subdivisions', subdivisions)
    },
  },
}